export const SET_SELECTED_TREE_ITEMS = 'SET_SELECTED_TREE_ITEMS';
export const SET_SELECTED_FEATURED_ITEM = 'SET_SELECTED_FEATURED_ITEM';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/shared/lotto/filter/mutationTypes.ts